import { render, staticRenderFns } from "./NBadge.vue?vue&type=template&id=2234aa39"
import script from "./NBadge.vue?vue&type=script&lang=js"
export * from "./NBadge.vue?vue&type=script&lang=js"
import style0 from "./NBadge.vue?vue&type=style&index=0&id=2234aa39&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports